import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Layout, Logo, Content } from "./styles";
import constants from "../../../constants";

interface ComponentProps {}

const Component = ({}: ComponentProps) => {
  return (
    <Layout>
      <Content>
        <Logo src={constants.company.logoBlack} alt="Dev Place" width="253px" />
        <Outlet />
      </Content>
      <ToastContainer />
    </Layout>
  );
};

export default Component;
